import * as React from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { media } from 'src/utils.js'
import { Logo, Nav } from './TopNavigationCleverStyle'
import CustomModal from '../containers/CustomModal'
import PhoneNumberClever from '../atoms/PhoneNumberClever'
import { RedBtn } from '../atoms/input/buttons'

const googleTrust = require('src/assets/configurator/google_reviews.png')
const trustedShop = require('src/assets/redesign/trusted_shops_logo.png')
const LogoImg = require('../../assets/logo_clever.png')

export const TopNavigationClever = () => {
  const [modalOpen, setModalOpen] = React.useState<boolean>(false)

  const openModal = (e) => {
    if (
      location.href.includes('planung') &&
      !location.href.includes('detail')
    ) {
      e.preventDefault()
      setModalOpen(true)
    }
  }
  const onCloseModal = () => {
    setModalOpen(false)
  }

  return (
    <>
      <DontLeave open={modalOpen} onClose={onCloseModal} />
      <Nav>
        <Logo>
          <a href='/' target='_self' onClick={openModal}>
            <img src={LogoImg} />
          </a>
        </Logo>
        <PhoneNumberClever />
      </Nav>
    </>
  )
}

interface DontLeaveProps {
  open: boolean
  onClose: () => void
}

export const DontLeave = (props: DontLeaveProps) => {
  const { open, onClose } = props
  return (
    <CustomModal
      onClose={onClose}
      open={open}
      title='Fast geschafft'
      cancelX
      hideCloseButton>
      <p>
        Transparenz ist im Bestattungsbereich nicht selbstverständlich. Sie sind
        nur noch wenige Schritte von einem kompletten Angebot mit sämtlichen
        Kosten und Gebühren entfernt.
      </p>
      <RedBtn onClick={onClose} center>
        Planung fortsetzen
      </RedBtn>
      <ImageAlign>
        <img src={googleTrust} width='80' alt='Google' />
        <img src={trustedShop} width='35' alt='SSL Secure Connection' />
      </ImageAlign>
      <p style={{ color: 'red', margin: 15 }}>
        Wenn sie jetzt Ihre Anfrage stornieren, gehen alle bereits eingegebenen
        Antworten verloren.
      </p>
      <CustomLink to='/' target='_self'>
        <u>Anfrage stornieren</u>
      </CustomLink>
    </CustomModal>
  )
}

const ImageAlign = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin: 7.5px;
  }
  ${media.largePhone`
    flex-direction: column;
  `}
`

const CustomLink = styled(Link)`
  font-size: 15px;
  color: #040a31;
`

export default withRouter(TopNavigationClever)



// WEBPACK FOOTER //
// ./src/components/layout/TopNavigationClever.tsx